const vn = {
  name: "tên",
  category: "danh mục",
  addProduct: "Thêm sản phẩm mới",
  plCode: "Xin vui lòng nhập mã phân loại",
  plName: "Xin vui lòng nhập tên danh mục",
  selCategory: "Vui lòng chọn danh mục sản phẩm",
  code: "mã hóa",
  addCategory: "Danh mục mới",
  addSubCategory: "Thêm danh mục con",
  noDelTips1: "Có những sản phẩm trong danh mục này và không thể xóa được. ",
  tips: "mẹo",
  conTips: "Bạn có chắc chắn muốn xóa danh mục này không? ",
  noDelTips2: "Có các danh mục con trong danh mục này và không thể xóa được. ",
  plEnterName: "Xin vui lòng nhập tên danh mục",
  productList: "danh sách sản phẩm",
  delCategory: "Xóa danh mục",
  plSearch: "Vui lòng nhập từ khóa tìm kiếm",
  fetchFail: "Truy vấn danh mục sản phẩm không thành công",

  storeType: "Loại hàng tồn kho:",
  storeTypeCloumn: "Loại hàng tồn kho",
  storeTypeNum: "Số lượng",
  storeTypeCode: "mã vạch",
  hsCode: 'Mã HS',
  plHsCode: 'Vui lòng nhập mã HS',
  plChooseType: 'Vui lòng chọn loại',
  all: 'Tất cả',
  setCategoryOrg: 'Đặt phòng ban quản lý danh mục'
};

export default vn;